<template>
  <full-container>
    <template slot="header">
      <total style="margin-bottom: 16px" />
      <div class="toolbar">
        <el-form inline size="small">
          <el-form-item>
            <el-select
              style="width: 100px"
              clearable
              v-model="queryParams.state"
              placeholder="发货状态"
              @change="onSearch()"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              style="width: 220px"
              type="daterange"
              v-model="queryParams.dateSpan"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSearch()"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="queryParams.keyWord"
              clearable
              placeholder="发货单号/客户名称"
            >
              <template slot="append">
                <el-button icon="el-icon-search" @click="onSearch()" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button
            v-action="'/api/Mall/Parcel/Submit'"
            type="primary"
            size="small"
            @click="$router.push({ path: 'form' })"
            >新建发货单</el-button
          >
          <el-button
            v-action="'/api/Mall/Parcel/Download'"
            icon="el-icon-download"
            size="small"
            @click="onDownload"
          />
        </el-button-group>
      </div>
    </template>
    <!--表格-->
    <el-table v-loading="loading" :data="datalist.Items" height="100%">
      <el-table-column label="发货单号" width="220" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link type="primary" @click="currentTarget = row">
            {{ $utils.meta.format("courier", row.Courier) }}
            {{ row.Code || "————————————" }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="CustomerName"
        label="客户单位"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Linkman"
        label="联系人"
        min-width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Linktel"
        label="联系电话"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Address"
        label="联系地址"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column label="经办人" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ row.Dept }}
          {{ row.Submiter }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column label="打印次数" min-width="100">
        <template slot-scope="{ row }"> 已打印 {{ row.Printime }} 次 </template>
      </el-table-column>
      <el-table-column label="状态/操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-tag size="small" :type="stateColor(row.State)">
              {{ row.StateText }}
              <i class="el-icon-arrow-down" />
            </el-tag>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-action="'/api/Mall/Parcel/Submit'"
                :disabled="row.State != 0"
                @click.native="
                  $router.push({ path: `/mall/parcel/form/${row.Id}` })
                "
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Parcel/Confirm'"
                :disabled="row.State != 0"
                @click.native="onConfirm(row)"
                >发货</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Parcel/Sign'"
                :disabled="row.State != 1"
                @click.native="onSign(row)"
                >签收</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Parcel/Revoke'"
                :disabled="row.State == -1"
                @click.native="onRevoke(row)"
                >作废</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      slot="footer"
      background
      :page-size="queryParams.size"
      :total="datalist.TotalCount"
      @current-change="onSearch"
    />

    <!--详情抽屉-->
    <el-drawer
      :size="1000"
      @close="currentTarget = {}"
      :visible="!!currentTarget.Id"
    >
      <div slot="title" style="margin-bottom: 20px">
        <el-link
          icon="el-icon-caret-right"
          type="primary"
          @click="$router.push({ path: `detail/${currentTarget.Id}` })"
          >进入详情页</el-link
        >
      </div>
      <detail :id="currentTarget.Id" :key="currentTarget.Id" />
    </el-drawer>
  </full-container>
</template>


<script>
import confirmForm from "./confirm.vue";
export default {
  components: {
    total: () => import("./_total.vue"),
    detail: () => import("./detail.vue"),
  },
  data() {
    return {
      timer: null,
      loading: false,
      currentTarget: {},
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
      stateOptions: [
        {
          text: "已作废",
          value: -1,
        },
        {
          text: "待确认",
          value: 0,
        },
        {
          text: "运送中",
          value: 1,
        },
        {
          text: "已签收",
          value: 9,
        },
      ],
    };
  },
  destroyed() {
    //离开页面是销毁轮询
    clearInterval(this.timer);
  },
  created() {
    //默认执行一次
    this.loadData();
    // 实现轮询
    this.timer = window.setInterval(() => {
      setTimeout(this.loadData(), 0);
    }, 1000 * 60);
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.mall.parcel
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 下载数据
    onDownload() {
      this.$confirm(
        "此操作将根据当前条件下载数据到Execl中,数据过多时需要花费一定时间才能完成操作，是否继续？",
        `下载数据（xls）`,
        {
          center: true,
          type: "warning",
        }
      ).then(() => {
        //开始下载
        this.loading = true;
        this.$apis.mall.parcel
          .download(this.queryParams)
          .then((res) => {
            this.$message({ message: res, type: "success" });
          })
          .catch((e) => {
            this.$message.error(e || "操作失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    //确认
    onConfirm(row) {
      this.$layer.iframe({
        title: `确认${row.Code}`,
        area: ["360px", "auto"],
        content: {
          content: confirmForm,
          data: {
            _form: {
              Id: row.Id,
              Code: row?.Code,
              Courier: row?.Courier,
            },
            callback: this.loadData,
          },
        },
      });
    },

    //签收
    onSign(row) {
      this.$prompt(null, `签收${row.Code}`, {
        inputPlaceholder: "请输入代签收备注...",
        center: true,
        callback: (action, { inputValue }) => {
          if (inputValue && action === "confirm") {
            this.$apis.mall.parcel
              .sign({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，货品已签收！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },

    //作废
    onRevoke(row) {
      this.$prompt(null, `作废${row.Code || ""}`, {
        inputPlaceholder: "请输入作废原因...",
        center: true,
        callback: (action, { inputValue }) => {
          if (inputValue && action === "confirm") {
            this.$apis.mall.parcel
              .revoke({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，发货单已作废！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },
  },
  computed: {
    stateColor() {
      return (state) => {
        switch (state) {
          case -1:
            return "info";
          case 0:
            return "primary";
          case 1:
            return "warning";
          case 9:
            return "success";
          default:
            return null;
        }
      };
    },
  },
};
</script>
